/**
 * REEMPLAZA: frontend/src/pages/Home.js
 */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiFetch, C } from "../api";

export default function Home() {
  const { user } = useAuth();
  const [content, setContent] = useState(null);

  useEffect(() => {
    apiFetch("/landing").then(setContent).catch(() => {});
  }, []);

  if (!content) return (
    <div style={{ minHeight:"100vh", background:C.bg, display:"flex", alignItems:"center", justifyContent:"center" }}>
      <div style={{ color:C.muted }}>Cargando…</div>
    </div>
  );

  const { hero, features, pricing, navbar, footer } = content;

  return (
    <div style={{ minHeight:"100vh", background:C.bg, display:"flex", flexDirection:"column" }}>
      {/* Navbar */}
      <nav style={{ display:"flex", alignItems:"center", padding:"0 2rem", height:"56px",
        borderBottom:`1px solid ${C.border}`, position:"sticky", top:0, background:C.bg, zIndex:100 }}>
        <span style={{ fontWeight:800, fontSize:"1.1rem", color:C.accent, letterSpacing:"-0.03em" }}>
          {navbar?.brand || "CodePad"}
        </span>
        <div style={{ marginLeft:"auto", display:"flex", gap:"12px", alignItems:"center" }}>
          {user ? (
            <Link to="/dashboard" style={{ background:C.accent, color:"#0d0d0f", borderRadius:"7px",
              padding:"7px 18px", fontWeight:700, fontSize:"0.83rem", textDecoration:"none" }}>Dashboard</Link>
          ) : (
            <>
              <Link to="/login" style={{ color:C.muted, textDecoration:"none", fontSize:"0.83rem" }}>Login</Link>
              <Link to="/login" style={{ background:C.accent, color:"#0d0d0f", borderRadius:"7px",
                padding:"7px 18px", fontWeight:700, fontSize:"0.83rem", textDecoration:"none" }}>
                {navbar?.cta || "Empezar"}
              </Link>
            </>
          )}
        </div>
      </nav>

      {/* Hero */}
      <section style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center",
        justifyContent:"center", textAlign:"center", padding:"6rem 2rem 4rem" }}>
        {hero?.badge && (
          <div style={{ fontSize:"0.78rem", letterSpacing:"0.15em", textTransform:"uppercase", color:C.muted,
            border:`1px solid ${C.border}`, borderRadius:"20px", padding:"4px 16px", display:"inline-block", marginBottom:"1.5rem" }}>
            {hero.badge}
          </div>
        )}
        <h1 style={{ fontWeight:800, fontSize:"clamp(2.5rem,6vw,4.5rem)", lineHeight:1.1,
          letterSpacing:"-0.04em", marginBottom:"1.5rem", maxWidth:"800px" }}>
          {hero?.title}{" "}
          {hero?.highlight && <span style={{ color:C.accent }}>{hero.highlight}</span>}
        </h1>
        {hero?.subtitle && (
          <p style={{ color:C.muted, fontSize:"1.1rem", maxWidth:"540px", lineHeight:1.7, marginBottom:"2.5rem" }}>
            {hero.subtitle}
          </p>
        )}
        <div style={{ display:"flex", gap:"12px", flexWrap:"wrap", justifyContent:"center" }}>
          <Link to={user ? "/dashboard" : "/login"}
            style={{ background:C.accent, color:"#0d0d0f", borderRadius:"8px", padding:"13px 30px",
              fontWeight:700, fontSize:"0.95rem", textDecoration:"none" }}>
            {hero?.cta_primary || "Empezar"}
          </Link>
          {hero?.cta_secondary && (
            <Link to="/login" style={{ border:`1px solid ${C.border}`, color:C.text, borderRadius:"8px",
              padding:"13px 30px", fontWeight:600, fontSize:"0.95rem", textDecoration:"none" }}>
              {hero.cta_secondary}
            </Link>
          )}
        </div>
      </section>

      {/* Features */}
      {features?.length > 0 && (
        <section style={{ padding:"4rem 2rem", maxWidth:"1100px", margin:"0 auto", width:"100%" }}>
          <h2 style={{ textAlign:"center", fontWeight:800, fontSize:"2rem", marginBottom:"3rem", letterSpacing:"-0.03em" }}>
            Todo lo que necesitás
          </h2>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:"1rem" }}>
            {features.map((f, i) => (
              <div key={i} style={{ background:C.surface, border:`1px solid ${C.border}`,
                borderRadius:"14px", padding:"1.75rem" }}>
                <div style={{ fontSize:"2rem", marginBottom:"0.75rem" }}>{f.icon}</div>
                <div style={{ fontWeight:700, fontSize:"1.05rem", marginBottom:"6px" }}>{f.title}</div>
                <div style={{ color:C.muted, fontSize:"0.85rem", lineHeight:1.6 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Pricing */}
      {pricing?.length > 0 && (
        <section style={{ padding:"4rem 2rem", maxWidth:"900px", margin:"0 auto", width:"100%" }}>
          <h2 style={{ textAlign:"center", fontWeight:800, fontSize:"2rem", marginBottom:"3rem", letterSpacing:"-0.03em" }}>
            Precios simples
          </h2>
          <div style={{ display:"grid", gridTemplateColumns:`repeat(${pricing.length},1fr)`, gap:"1rem" }}>
            {pricing.map((p, i) => (
              <div key={i} style={{ background: p.highlighted ? "#1a1a00" : C.surface,
                border:`2px solid ${p.highlighted ? C.accent : C.border}`,
                borderRadius:"16px", padding:"2rem", textAlign:"center", position:"relative" }}>
                {p.highlighted && (
                  <div style={{ position:"absolute", top:"-13px", left:"50%", transform:"translateX(-50%)",
                    background:C.accent, color:"#0d0d0f", borderRadius:"20px", padding:"3px 14px",
                    fontSize:"0.72rem", fontWeight:700 }}>Popular</div>
                )}
                <div style={{ fontWeight:700, fontSize:"1.1rem", marginBottom:"4px" }}>{p.name}</div>
                <div style={{ color:C.muted, fontSize:"0.82rem", marginBottom:"1.5rem" }}>{p.desc}</div>
                <div style={{ fontWeight:800, fontSize:"2.5rem", color:C.accent, marginBottom:"1.5rem" }}>
                  ${p.price}<span style={{ fontSize:"1rem", color:C.muted }}>/mes</span>
                </div>
                <ul style={{ listStyle:"none", marginBottom:"1.5rem", textAlign:"left" }}>
                  {p.features?.map((f, j) => (
                    <li key={j} style={{ fontSize:"0.85rem", color:C.muted, padding:"4px 0",
                      display:"flex", gap:"8px", alignItems:"center" }}>
                      <span style={{ color:C.success }}>✓</span> {f}
                    </li>
                  ))}
                </ul>
                <Link to="/login" style={{ display:"block", background: p.highlighted ? C.accent : "transparent",
                  border:`1px solid ${p.highlighted ? C.accent : C.border}`,
                  color: p.highlighted ? "#0d0d0f" : C.text, borderRadius:"8px",
                  padding:"10px", fontWeight:700, fontSize:"0.85rem", textDecoration:"none" }}>
                  {p.cta}
                </Link>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Footer */}
      <footer style={{ padding:"2rem", textAlign:"center", color:C.muted, fontSize:"0.82rem",
        borderTop:`1px solid ${C.border}`, marginTop:"4rem" }}>
        {footer?.text || "CodePad"}
      </footer>
    </div>
  );
}
